<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>我的消息</p>
    </div>
    <div class="panel-content">
      <div id="list">
        <table v-if="tableData.length">
          <tr class="l_header">
            <th>消息主题</th>
            <th>发送人</th>
            <th>时间</th>
            <th>状态</th>
            <th
              class="action"
              width="180"
            >操作</th>
          </tr>
          <tr
            class="item"
            v-for="(item,index) in tableData"
            :key="index"
          >
            <td>{{item.message.title}}</td>
            <td>{{item.message.creator.name}}</td>
            <td>{{item.message.sendTime.replace('T',' ')}}</td>
            <td>{{item.status?'已读':'未读'}}</td>
            <td class="action">
              <a
                class="edit"
                href="javascript:;"
                @click="querySingle(item.id)"
              >查看</a>
              <a
                class="delete"
                href="javascript:;"
                @click="askDelete(item.id)"
              >删除</a>
            </td>
          </tr>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
    <div
      class="form_overlay"
      id="form_overlay"
      :style="classShowEditWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require"></i>{{formInfo.title}}</span>
              <textarea
                id=""
                v-model="formInfo.content"
              ></textarea>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="readInfo"
          >确定</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'Feedback',
  components: {
    Pagination
  },
  data() {
    return {
      classShowEditWindow: {},
      queryInfo: {
        page: 1,
        size: 10,
        userprofile_id: this.$store.state.userInfo.profile_id
      },
      tableData: [],
      tableDataCount: 0,
      formInfo: {
        title: '',
        content: ''
      }
    }
  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }
  },
  methods: {
    formatTime(val) {
      return val.replace('T', ' ').substring(0, val.indexOf('.'))
    },
    async search() {
      await this.$http.get('/user_message/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    showEditWindow() {
      this.classShowEditWindow = { visibility: 'visible' }
    },
    hideEditWindow() {
      this.classShowEditWindow = { visibility: 'hidden' }
    },
    // 编辑时查询
    async querySingle(id) {
      const url = '/user_message/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo = {
          id: data.id,
          message_id: data.message.id,
          title: data.message.title,
          content: data.message.content,
          status: data.status,
          sendTime: data.message.sendTime
        }
        this.showEditWindow()
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('数据获取失败！')
      })
    },
    async readInfo() {
      const url = '/user_message/' + this.formInfo.id + '/'
      if (!this.formInfo.status) {
        await this.$http.put(url, {
          userprofile_id: this.$store.state.userInfo.profile_id,
          message_id: this.formInfo.message_id,
          status: 1
        }).then((data) => {
          this.hideEditWindow()
          this.search()
          this.$parent.getMessageCount()
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('数据获取失败！')
        })
      } else {
        this.hideEditWindow()
      }
    },

    // 删除
    async askDelete(id) {
      const url = '/user_message/' + id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          isdel: 1
        }).then((data) => {
          this.$layer.msg('删除成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('删除失败！')
        })
      })
    },

    // 分页
    async pageCallback(data) {
      this.queryInfo.page = data
      await this.search()
    }
  },
  mounted() {
    this.search()
  }
}
</script>
<style lang="less" scoped>
textarea {
  min-height: 200px;
  resize: none;
}
#list .send {
  color: orange;
  text-decoration: underline;
}
#itemForm .item {
  display: flex;
  flex-direction: column;
}
#itemForm .item span,
#itemForm .item textarea {
  width: 100%;
}
.form_control {
  display: flex;
  justify-content: center;
  padding: 0;
}
.form_control a {
  margin: 0;
}
</style>
